// Imports => Constants
import { ENDPOINTS } from '@constants';

export class TransactionsAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  list = (params) => {
    return this.Client.get(ENDPOINTS.TRANSACTIONS.LIST, { params }).then(
      (response) => response.data
    );
  };

  get_by_id = (uid, params) => {
    return this.Client.get(ENDPOINTS.TRANSACTIONS.GET_BY_ID(uid), {
      params,
    }).then((response) => response.data.data);
  };

  get_changelog = (uid, params) => {
    return this.Client.get(ENDPOINTS.TRANSACTIONS.GET_LOG(uid), {
      params,
    }).then((response) => response.data.data);
  };

  get_tracking = (uid, params) => {
    return this.Client.get(ENDPOINTS.TRANSACTIONS.GET_TRACKING(uid), {
      params,
    }).then((response) => response.data.data);
  };

  get_tracking_by_id = (uid, tracking_uid, params) => {
    return this.Client.get(
      ENDPOINTS.TRANSACTIONS.GET_TRACKING_BY_ID(uid, tracking_uid),
      {
        params,
      }
    ).then((response) => response.data.data);
  };

  get_refundable = (uid) => {
    return this.Client.get(
      ENDPOINTS.TRANSACTIONS.REFUNDABLE(uid)
    ).then((response) => response.data.data);
  };

  get_payouts = (uid) => {
    return this.Client.get(
      ENDPOINTS.TRANSACTIONS.GET_PAYOUTS(uid)
    ).then((response) => response.data.data);
  };

  get_refund_payouts = (uid) => {
    return this.Client.get(
      `${ENDPOINTS.TRANSACTIONS.GET()}?refund_uid=${uid}&date_start=01-01-2000&expand[]=refunds`
    ).then((response) => response.data.data);
  };

  store_refund = (uid, params) => {
    return this.Client.post(
      ENDPOINTS.TRANSACTIONS.STORE_REFUND(uid),
      params,
    ).then((response) => response.data.data);
  };

  store_topup = (uid, params) => {
    return this.Client.post(
      ENDPOINTS.TRANSACTIONS.STORE_TOPUP,
      {
        transaction_uid: uid,
        ...params,
      }
    ).then((response) => response.data.data);
  };
}

export default TransactionsAPI;
